
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getFavorites } from './utils/favorites';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SearchOverlay from './components/SearchOverlay';

// Pages
import Home from './pages/Home';
import Categories from './pages/Categories';
import Favorites from './pages/Favorites';
import About from './pages/About';

import './style.css';

function App() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [favorites, setFavorites] = useState(() => getFavorites());

  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  const handleFavoriteChange = (newFavorites) => {
    setFavorites(newFavorites);
  };

  return (
    <Router>
      <div className="app">
        <Navbar onSearchToggle={toggleSearch} />
        
        <main className="main-content">
          <Routes>
            <Route 
              path="/" 
              element={<Home onFavoriteChange={handleFavoriteChange} />} 
            />
            <Route 
              path="/categories" 
              element={<Categories onFavoriteChange={handleFavoriteChange} />} 
            />
            <Route 
              path="/favorites" 
              element={
                <Favorites 
                  favorites={favorites} 
                  onFavoriteChange={handleFavoriteChange} 
                />
              } 
            />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>

        <Footer />

        <SearchOverlay
          isOpen={searchOpen}
          onClose={() => setSearchOpen(false)}
          onFavoriteChange={handleFavoriteChange}
        />
      </div>
    </Router>
  );
}

export default App;